import {Field, Formik} from "formik";
import {useMutation} from "react-query";
import {useHistory} from 'react-router-dom';
import {Dialog} from "@headlessui/react";
import { toast } from "react-toastify";
import UTILS from "../../utils";
import Blocks from "../blocks";
import Fields from "../formFields";
import Partials from "../partials";
import SignupBg from "../../assets/images/study-signup.svg";
import {completeProfile} from "../../api/students";
import {useEffect, useState} from "react";
import moment from "moment";

const PageStudentCompleteProfile = () => {
    const history = useHistory();
    const [isDialogOpen, _setIsDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [initialValues, _setInitialValues] = useState({
        id: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        dob: new Date(),
        gender: {value: "male", label: "Male"},
        photo: ''
    })
    const [isPasswordVisible, toggle] = useState(false);

    useEffect(() => {
        const student = JSON.parse(sessionStorage.getItem("stud_info"));
        if (student) {
            const newInitValues = {
                id: student.id,
                email: student.email,
                first_name: student.first_name,
                last_name: student.last_name,
                mobile_number: student.mobile_number,
                gender: student?.gender
            }

            _setInitialValues({...initialValues, ...newInitValues});
        }
    }, []);

    const {isLoading, error, isError, mutate, data} = useMutation(completeProfile, {
        onSuccess: (data) => {
            history.push(`/login`)
        },
        onError: (err) => {
       console.log(err);
       if (err.response?.status >= 400 && err.response?.status < 600) {
        const errorMessage = err.response?.data?.message || 
                           err.message || 
                           "An error occurred while updating your profile";
        setErrorMessage(errorMessage);
        if (err.response?.status >= 500) {
          toast.error(errorMessage);
        }
      }
    },
    });

    const signUpSubmit = (values, action) => {
        // Clear any previous error messages
        setErrorMessage("");
        
        const {first_name, last_name, mobile_number, dob, gender, photo, password, email} = values;
        const student_obj = {
            id: values.id,
            data: {
                id: values.id,
                first_name,
                last_name,
                mobile_number,
                email,
                photo: photo.replace("data:", "").replace(/^.+,/, ""),
                password,
                user_attributes: [
                    {name: "dob", value: moment(dob).unix()},
                    {name: "gender", value: gender.value},
                ],
            },
        }
        mutate(student_obj);
    }

    return (
        <div className={'page PageStudentCompleteProfile'}>
            <div className="container mx-auto">
                <h3 className={"block md:hidden text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"}>{'Complete your student profile'}</h3>
                <div className="relative flex flex-col md:flex-row items-center">
                    <Dialog
                        open={isDialogOpen}
                        onClose={() => _setIsDialogOpen(false)}
                        className="absolute w-80 h-96 z-10 right-1/2 bottom-1/2 translate-x-2/4 translate-y-2/4 border-2 border-b-blue-800"
                    >
                        <Dialog.Overlay/>
                        <Dialog.Title>Camera</Dialog.Title>
                        <Dialog.Description>

                        </Dialog.Description>
                        <button onClick={() => _setIsDialogOpen(false)}>Capture</button>
                    </Dialog>
                    <div className="bgWrapper md:flex justify-center items-center bg-white">
                        <img src={SignupBg} alt="" draggable={false}/>
                    </div>
                    <div
                        className="pageContent w-full max-w-lg mx-auto md:mr-0 md:ml-auto mt-4 md:mt-0  mb-4 bg-white p-4 rounded-xl">
                        <h4 className={'hidden md:block text-2xl font-subheading'}>{'Complete your student profile'}</h4>
                        
                        {/* Display error message if exists */}
                        {errorMessage && (
                            <div className="mb-4 p-3 bg-red-100 border-l-4 border-red-500 text-red-700">
                                <p>{errorMessage}</p>
                            </div>
                        )}
                        
                        <Blocks.ErrorBoundary>
                            <Formik
                                enableReinitialize
                                initialValues={initialValues}
                                validationSchema={UTILS.forms.completeProfileStudent}
                                onSubmit={signUpSubmit}
                            >
                                {({
                                      handleSubmit,
                                      isSubmitting,
                                  }) => (
                                    <form onSubmit={handleSubmit} className="pt-6 pb-8">
                                        <div className="md:grid md:grid-cols-2 gap-4">
                                            <Field type={'text'} name="first_name" placeholder="First Name"
                                                   iconBefore={<i className={`text-xl icon icon-user`}></i>}
                                                   component={Fields.FieldInput} disabled/>
                                            <Field type='text' name="last_name" placeholder="Last Name"
                                                   iconBefore={<i className={`text-xl icon icon-user`}></i>}
                                                   component={Fields.FieldInput} disabled/>
                                        </div>

                                        <div className="md:grid md:grid-cols-2 gap-4">
                                            <Field type='text' name="mobile_number" placeholder="Mobile number"
                                                   iconBefore={<i className={`text-xl icon icon-phone`}></i>}
                                                   component={Fields.FieldInput} disabled/>
                                            <Field type='email' name="email" placeholder="Email Id"
                                                   iconBefore={<i className={`text-xl icon icon-mail1`}></i>}
                                                   component={Fields.FieldInput} disabled/>
                                        </div>

                                        <p className={"mb-2"}>Add further details</p>
                                        <div className="md:grid md:grid-cols-2 gap-4">
                                            <Field type='date' name="dob" placeholder="Date of Birth"
                                                   iconBefore={<span>DOB</span>}
                                                   max={moment().format('YYYY-MM-DD')}
                                                   component={Fields.FieldInput}/>
                                            <Field name="gender"
                                                   iconBefore={<span>Gender</span>}
                                                   options={[
                                                       {value: "male", label: "Male"},
                                                       {value: "female", label: "Female"},
                                                   ]}
                                                   component={Fields.FieldSelect}/>
                                        </div>

                                        <Field name={"photo"}
                                               component={Fields.FieldCameraInput} isFileUpload/>

                                        <Field type={!isPasswordVisible ? 'password' : 'text'} name="password"
                                               placeholder="Password"
                                               iconBefore={<i className={`text-xl icon icon-unlock`}></i>}
                                               iconAfter={<i
                                                   className={`text-xl cursor-pointer icon icon-${!isPasswordVisible ? 'eye-off' : 'eye'}`}
                                                   onClick={() => toggle(!isPasswordVisible)}></i>}
                                               component={Fields.FieldInput}/>

                                        <button
                                            disabled={isSubmitting || isLoading}
                                            className="bg-black w-full hover:bg-zinc-700 text-white inline-flex justify-center font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline transition ease-in-out duration-150"
                                            type="submit">
                                            {isLoading || isLoading &&
                                                <Partials.PartialLoading/>
                                            }
                                            Submit
                                        </button>
                                    </form>
                                )}
                            </Formik>
                        </Blocks.ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageStudentCompleteProfile;